module.exports = __webpack_public_path__ + "static/tel2-d1f8c7e430e34b684cc92ac4b9e5489a.png";